$(document).ready(function(){

    // home image slider
    $(".img-slider-list").slick({
        dots: false,
        arrows: true,
        infinite: true,
        nextArrow: '<div class="next_arrow_slick"><svg width="9" height="17" viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.14456 0.199839L8.67102 7.92093C8.80321 8.05655 8.8772 8.23844 8.8772 8.42782C8.8772 8.61721 8.80321 8.7991 8.67102 8.93472L1.14456 16.6587C1.08298 16.722 1.00936 16.7722 0.928039 16.8065C0.846716 16.8409 0.759341 16.8586 0.671072 16.8586C0.582803 16.8586 0.495426 16.8409 0.414104 16.8065C0.332781 16.7722 0.259158 16.722 0.197581 16.6587C0.0708866 16.529 -4.3869e-05 16.3549 -4.3869e-05 16.1736C-4.3869e-05 15.9923 0.0708866 15.8182 0.197581 15.6885L7.27524 8.42782L0.197581 1.16861C0.0713215 1.03898 0.000665665 0.865177 0.000665665 0.684223C0.000665665 0.503268 0.0713215 0.329466 0.197581 0.199839C0.259158 0.136596 0.332781 0.086329 0.414104 0.0520061C0.495426 0.0176833 0.582803 0 0.671072 0C0.759341 0 0.846716 0.0176833 0.928039 0.0520061C1.00936 0.086329 1.08298 0.136596 1.14456 0.199839Z" fill="black"/></svg></div>',
        prevArrow: '<div class="prev_arrow_slick"><svg width="9" height="17" viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.73264 0.199839L0.206173 7.92093C0.0739825 8.05655 0 8.23844 0 8.42782C0 8.61721 0.0739825 8.7991 0.206173 8.93472L7.73264 16.6587C7.79421 16.722 7.86784 16.7722 7.94916 16.8065C8.03048 16.8409 8.11786 16.8586 8.20613 16.8586C8.29439 16.8586 8.38177 16.8409 8.46309 16.8065C8.54442 16.7722 8.61804 16.722 8.67962 16.6587C8.80631 16.529 8.87724 16.3549 8.87724 16.1736C8.87724 15.9923 8.80631 15.8182 8.67962 15.6885L1.60195 8.42782L8.67962 1.16861C8.80588 1.03898 8.87653 0.865177 8.87653 0.684223C8.87653 0.503268 8.80588 0.329466 8.67962 0.199839C8.61804 0.136596 8.54442 0.086329 8.46309 0.0520061C8.38177 0.0176833 8.29439 0 8.20613 0C8.11786 0 8.03048 0.0176833 7.94916 0.0520061C7.86784 0.086329 7.79421 0.136596 7.73264 0.199839Z" fill="black"/></svg></div>',
        speed: 700,
        adaptiveHeight: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 993,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 749,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    // home FAQ
    $('.acc-container').on('click', '.acc__title', function (e) {
        var accCard = $(this).closest('.acc__card');
        var accPanel = accCard.find('.acc__panel');
        var accTitle = $(this);
    
        if (accCard.hasClass('active_item')) {
            accCard.removeClass('active_item');
            accTitle.removeClass('active');
            accPanel.stop(true, true).slideUp();
        } else {
            $(this).closest('.acc-container').find('.acc__card.active_item')
                .removeClass('active_item')
                .find('.acc__panel').stop(true, true).slideUp()
                .end().find('.acc__title').removeClass('active');
            accCard.addClass('active_item');
            accTitle.addClass('active');
            accPanel.stop(true, true).slideDown();
        }
        e.preventDefault();
    });

    // product page gallery slider
    $(".main-gallery-slick-enabled").not('.slick-initialized').slick({
        dots: false,
        arrows: true,
        prevArrow: '<div class="arrow_prev"><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.506463 9.72394L8.511 17.3507C8.64456 17.478 8.822 17.5491 9.00652 17.5491C9.19104 17.5491 9.36849 17.478 9.50205 17.3507L9.51066 17.3421C9.57564 17.2804 9.62737 17.2061 9.66272 17.1237C9.69808 17.0414 9.71631 16.9527 9.71631 16.8631C9.71631 16.7735 9.69808 16.6848 9.66272 16.6025C9.62737 16.5201 9.57564 16.4458 9.51066 16.3841L1.97293 9.20256L9.51066 2.0239C9.57564 1.96218 9.62737 1.88789 9.66272 1.80554C9.69808 1.72319 9.71631 1.63451 9.71631 1.5449C9.71631 1.45528 9.69808 1.3666 9.66272 1.28425C9.62737 1.20191 9.57564 1.12761 9.51066 1.06589L9.50205 1.05727C9.36849 0.929949 9.19104 0.858921 9.00652 0.858921C8.822 0.858921 8.64456 0.929949 8.511 1.05727L0.506463 8.68405C0.436066 8.75113 0.380023 8.83179 0.34173 8.92117C0.303437 9.01054 0.283691 9.10676 0.283691 9.204C0.283691 9.30123 0.303437 9.39745 0.34173 9.48683C0.380023 9.5762 0.436066 9.65687 0.506463 9.72394Z" fill="black"/></svg></div>',
        nextArrow: '<div class="arrow_next"><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.59852 9.72394L1.59398 17.3507C1.46042 17.478 1.28298 17.5491 1.09846 17.5491C0.913936 17.5491 0.736493 17.478 0.602934 17.3507L0.594316 17.3421C0.529344 17.2804 0.477609 17.2061 0.442256 17.1237C0.406903 17.0414 0.388672 16.9527 0.388672 16.8631C0.388672 16.7735 0.406903 16.6848 0.442256 16.6025C0.477609 16.5201 0.529344 16.4458 0.594316 16.3841L8.13205 9.20256L0.594316 2.0239C0.529344 1.96218 0.477609 1.88789 0.442256 1.80554C0.406903 1.72319 0.388672 1.63451 0.388672 1.5449C0.388672 1.45528 0.406903 1.3666 0.442256 1.28425C0.477609 1.20191 0.529344 1.12761 0.594316 1.06589L0.602934 1.05727C0.736493 0.929949 0.913936 0.858921 1.09846 0.858921C1.28298 0.858921 1.46042 0.929949 1.59398 1.05727L9.59852 8.68405C9.66891 8.75113 9.72496 8.83179 9.76325 8.92117C9.80154 9.01054 9.82129 9.10676 9.82129 9.204C9.82129 9.30123 9.80154 9.39745 9.76325 9.48683C9.72496 9.5762 9.66891 9.65687 9.59852 9.72394Z" fill="black"/></svg></div>',
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        asNavFor: '.main-thumbs-slick-enabled',
        slidesToScroll: 1,
        autoplay: false
    });

    $(".main-thumbs-slick-enabled").not('.slick-initialized').slick({
        dots: false,
        asNavFor: '.main-gallery-slick-enabled',
        arrows: false,
        infinite: false,
        slidesToShow: 4,
        verticalSwiping: true,
        vertical: true,
        autoplay: false,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 749,
                settings: {
                    verticalSwiping: false,
                    vertical: false
                }
            }
        ]
    });

    $(window).on('load', function () {
        $('.main-gallery-slick-enabled, .main-thumbs-slick-enabled').slick('setPosition');
    });

    $('.main-thumbs-slick-enabled').slick('refresh');
    
    setTimeout(function(){
        $('.main-thumbs-slick-enabled').slick('setPosition');
    }, 300);

    $(window).on('resize orientationchange', function () {
        $('.main-gallery-slick-enabled').slick('setPosition');
        $('.main-thumbs-slick-enabled').slick('setPosition');
    });

    $(".main-gallery-slick-enabled").on('afterChange', function(event, slick, currentSlide){
        console.log("currentSlide: ",currentSlide);
        var indexslide = currentSlide+1;
        console.log("Current Slide Index:", indexslide);
        $("ul.thumbnail-list li button[aria-current]").removeAttr("aria-current");
        $('ul.thumbnail-list li[data-media-position="' + indexslide + '"] button').attr("aria-current", "true");
    });

    $("ul.thumbnail-list").on("click", "li button", function () {
        var index = $(this).closest("li").data("media-position");
        console.log("index ",index);
        if (typeof index !== 'undefined') {
            var slideIndex = [parseInt(index, 10)]-1;
            console.log("slideIndexslideIndex ",slideIndex);
            $(".main-gallery-slick-enabled").slick("slickGoTo", slideIndex);
        }
    });

});